export const GROUP_ADMIN = 'Group Admin';
export const ORG_ADMIN = 'Org Admin';
export const ADMIN_ROLES = [GROUP_ADMIN, ORG_ADMIN];
